import { render, staticRenderFns } from "./itemEdit.vue?vue&type=template&id=3cd4c83a&scoped=true&"
import script from "./itemEdit.vue?vue&type=script&lang=js&"
export * from "./itemEdit.vue?vue&type=script&lang=js&"
import style0 from "./itemEdit.vue?vue&type=style&index=0&id=3cd4c83a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4c83a",
  null
  
)

export default component.exports